import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Device } from '../../../devices/devices.model_new';
import { SharedUtils } from '../../../../shared/shared.utils';

@Component({
  selector: 'app-scheduling-plc-update-dialog',
  templateUrl: './scheduling-plc-update-dialog.component.html',
  styleUrls: ['./scheduling-plc-update-dialog.component.scss']
})
export class SchedulingPlcUpdateDialogComponent implements OnInit {
  devices: Device[];
  moduleIds: string[];

  SharedUtils = SharedUtils;

  @Output() action: EventEmitter<string[]> = new EventEmitter<string[]>();

  constructor(
    public dialogRef: MatDialogRef<SchedulingPlcUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.devices = data.devices;
    this.moduleIds = data.moduleIds;
  }

  ngOnInit() {
  }

  hasDevice(device: Device): boolean {
    if ( this.moduleIds ) {
      return this.moduleIds.includes(device.getModuleId());
    } else {
      return false;
    }
  }

  onToogleDevice(device: Device): void {
    if (this.hasDevice(device)) {
      this.moduleIds.forEach((id, index) => {
        if (id === device.getModuleId()) {
          this.moduleIds.splice(index, 1);
        }
      });
    } else {
      this.moduleIds.push(device.getModuleId());
    }
  }

  onUpdate() {
    this.action.emit(this.moduleIds);
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling-tab/scheduling-plc-update-dialog/scheduling-plc-update-dialog.component.ts